module.exports = __webpack_public_path__ + "img/smp-map.19072585.png";